import { render, staticRenderFns } from "./ContentPageSlider.vue?vue&type=template&id=79074aa6&scoped=true&"
import script from "./ContentPageSlider.vue?vue&type=script&lang=ts&"
export * from "./ContentPageSlider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79074aa6",
  null
  
)

export default component.exports